import "../Default.css"
import type Terms from "./termsOfUseType"
import data from "./termsOfUse.json"
const terms: Terms = data as any;

function TermsOfUse() {
    return (
        <>
            <div className="page-title">
                Warunki użytkowania
            </div>
            <div className='text'>
                {terms.paragraphs.map((paragraph, index) =>
                    <div className='paragraf' key={index}>
                        {paragraph}
                    </div>
                )}
            </div>
        </>
    )
}

export default TermsOfUse;